export const MMA_HEADER_COPY = {
  eyebrow: 'Sports Hub · MMA',
  title: 'MMA Terminal',
  description: 'Track live fights, odds, and fighter analytics across MMA events worldwide.'
};
